import { ISetNameParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class RenameMetricRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('renameMetric', {
      id: id,
      name: name
    });
  }
}
